import { render, staticRenderFns } from "./dialogRemotePolicy.vue?vue&type=template&id=5ec098f4&scoped=true&lang=pug&"
import script from "./dialogRemotePolicy.vue?vue&type=script&lang=js&"
export * from "./dialogRemotePolicy.vue?vue&type=script&lang=js&"
import style0 from "./dialog.scss?vue&type=style&index=0&id=5ec098f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec098f4",
  null
  
)

export default component.exports